(function() {
  var Point = include("PIXI.Point"),
    Sprite = include("PIXI.Sprite"),
    Graphics = include("PIXI.Graphics"),
    Button = include("springroll.pixi.Button"),
    Container = include("PIXI.Container"),
    Text = include("PIXI.Text"),
    Tween = include("createjs.Tween"),
    Vector = include("WGBH.Vector"),
    UIPanel = include("WGBH.UIPanel"),
    EventDispatcher = include("springroll.EventDispatcher"),
    Phys = include("WGBH.PhysicsManagerBox2d"),
    Renderer = include("WGBH.PhysicsRenderer"),
    WorldObject = include("WGBH.WorldObject");

  /**
	 * The ice rink
	 * @class WGBH.IceRink
	 */
  var IceRink = function(options) {

    // includes the rendering for physics and some event sharing
    // all in-game physics items (including walls and the launcher), but not UI buttons

    this.events = new EventDispatcher();
  };

  // http://www.iforce2d.net/b2dtut/raycasting

  // Extend the base class
  var p = IceRink.prototype;

  var worldobjects, deadobjects, groupedobjects;
  var worldnames = {};

  var launcher,
    puck,
    phys,
    rend,
    victorydistance,
    aimtarget,
    proximity,
    level,
    patharrow;

  var maxforce, minforce;

  var slidemode = "v";
  var shotstaken;

  var launchertouch;

  var block = {
    left: null,
    top: null,
    bottom: null,
    right: null
  };

  block = null;

  var center, frame; // for moving the launcher around

  var t1 = 0;
  var t2 = 30;
  var t3 = 0;
  var restspeed = 10;
  var predict; // are we in prediction mode?
  var fv; //plushie velocity
  var closewalls; // keeps track of which walls are near the launcher so the puck doesn't react to them when it's first being launched

  var tracepaths = false;

  var playmode; // are we in play mode?
  var shot;
  var stasis = true;
  var reloading = false;
  var stoppredicting = false; // keeps player from changing their prediction after a shot

  var fullspeed = 16;
  var normal = 32;
  var slomo = 90;

  var vistick = normal;
  var phystick = normal;

  var historyframe;

  var collisions = {};
  var lastframes = {};
  var gamesettings = {};

  p.setup = function(panel, container, parent) {
    /* panel is the main panel this ice rink sits in, used for different panel-related things
		   container is the PIXI container in which all of this stuff is placed
		   parent is the state that calls the rink
		   */

    this.parent = parent;
    this.panel = panel;
    this.container = container;

    restspeed = app.config.phys.restspeed;

    maxforce = app.config.phys.maxforce;
    minforce = app.config.phys.minforce;

    launchertouch =
      app.config.gameoptions.launchertouchradius *
      app.config.gameoptions.launchertouchradius;

    victorydistance = {
      l:
        app.config.gameoptions.targetradius.l *
          app.config.gameoptions.targetradius.l,
      m:
        app.config.gameoptions.targetradius.m *
          app.config.gameoptions.targetradius.m,
      s:
        app.config.gameoptions.targetradius.s *
          app.config.gameoptions.targetradius.s
    };

	holedistance=app.config.gameoptions.holedistance;

    this.sense = this.sense.bind(this);
    this.collision = this.collision.bind(this);
    this.stopsense = this.stopsense.bind(this);
    this.update = this.update.bind(this);

    this.checkvictory = this.checkvictory.bind(this);

    this.reload = this.reload.bind(this);

    this.placetarget = this.placetarget.bind(this);

    this.togglestar = this.togglestar.bind(this);

    this.history = []; // for replay
    /* looks like this:
			history [
				shot {
					objects {
						id:{
							lastpath;
							path:[]
						}
					}
					launcher [position]
					force #amount
				}
			]
		*/

    this.document = {}; // given a particular location and value, what was the result? For single-shot only.

    this.draglauncher = this.draglauncher.bind(this);
    this.movelauncher = this.movelauncher.bind(this);
    this.droplauncher = this.droplauncher.bind(this);

    this.dragtarget = this.dragtarget.bind(this);
    this.movetarget = this.movetarget.bind(this);
    this.droptarget = this.droptarget.bind(this);

    this.dragitem = this.dragitem.bind(this);
    this.moveitem = this.moveitem.bind(this);
    this.dropitem = this.dropitem.bind(this);

    this.itemtoadd = ""; // for editing

    phys = new Phys();
    rend = new Renderer({ container: container });

    this.rend = rend;

    phys.setScale(app.config.phys.scale);
    phys.setGravity(0);
    rend.setphysics(phys);

    rend.container.interactive = true;

    launcher = this.panel.items.launcher;
    this.container.addChild(launcher);
    launcher.aim = new Point();
    launcher.angle = 0;

    launcher.last = new Point();

    // place the ice
    this.setsize(app.config.gameoptions.rinkframe);

    var iceshape = app.config.items.icebg.clone();
    iceshape.frame = { x: frame.x, y: frame.y };
    iceshape = this.panel.additem(iceshape, this.container);
    // move the shine OVER the target...
	iceshape.buttonMode = false; // only active to catch stray clicks; don't want user to know

    var iceshine = app.config.items.iceshine.clone();

    iceshine.frame = { x: frame.x + (frame.w-iceshine.frame.w)/2, y: frame.y +  (frame.h-iceshine.frame.h)/2};
    var ic = this.panel.additem(iceshine, this.container);
	var corners=[
		[frame.x,frame.y,-0.5,-0.5],
		[frame.x + frame.w,frame.y,0.5,-0.5],
		[frame.x + frame.w,frame.y+frame.h,0.5,0.5],
		[frame.x,frame.y + frame.h,-0.5,0.5]
	];
	for(var i=0;i<4;i++) {
    	var rinkcorner = app.config.items.rinkcorner.clone();
		offsetx=rinkcorner.frame.w*corners[i][2];
		offsety=rinkcorner.frame.h*corners[i][3];
		rinkcorner.frame={x:corners[i][0]+offsetx, y:corners[i][1]+offsety};
		var icecorner=this.panel.additem(rinkcorner,this.container);
		icecorner.rotation=Math.PI * (0.5*i);
	}

    this.penguinpathlayer = new Graphics();

    this.container.addChild(this.penguinpathlayer);
    this.targetvictory = this.panel.additem(
      app.config.items.targetwin,
      this.container
    );
    this.targetvictory.visible = false;
    this.targetvictory.targetring1 = this.panel.items.targetring1;
    this.targetvictory.targetring2 = this.panel.items.targetring2;
    this.targetvictory.targetring3 = this.panel.items.targetring3;

    this.targetvictory.targetring1.alpha = this.targetvictory.targetring2.alpha = this.targetvictory.targetring3.alpha = 0.75;

    var flash = function() {
      this.flashtimes--;
      this.visible = !this.visible;
      if (this.flashtimes > 0) {
        var me = this;
        app.setTimeout(me.flash, 100);
      } else {
        this.visible = false;
      }
    };

    this.targetvictory.targetring1.flash = flash.bind(
      this.targetvictory.targetring1
    );
    this.targetvictory.targetring2.flash = flash.bind(
      this.targetvictory.targetring2
    );
    this.targetvictory.targetring3.flash = flash.bind(
      this.targetvictory.targetring3
    );

    this.targetvictory.showring = function(which) {
      this.visible = true;
      var len;
      switch (which) {
        case 1:
          len = 10;
          this.targetring1.visible = false;
          this.targetring2.visible = true;
          this.targetring3.visible = false;
          this.targetring1.flashtimes = len;
          this.targetring1.flash();
          this.targetring2.flashtimes = len;
          this.targetring2.flash();
          this.targetring3.flashtimes = len;
          this.targetring3.flash();
          break;

        case 2:
          len = 8;
          this.targetring1.visible = false;
          this.targetring2.visible = true;
          this.targetring3.visible = false;
          this.targetring2.flashtimes = len;
          this.targetring2.flash();
          this.targetring3.flashtimes = len;
          this.targetring3.flash();
          break;

        case 3:
          len = 6;
          this.targetring1.visible = false;
          this.targetring2.visible = false;
          this.targetring3.visible = true;
          this.targetring3.flashtimes = len;
          this.targetring3.flash();
          break;

        case 4:
          len = 4;
          this.targetring1.visible = false;
          this.targetring2.visible = false;
          this.targetring3.visible = true;
          this.targetring3.flashtimes = len;
          this.targetring3.flash();
          break;
      }
    };

    patharrow = new Sprite(images.patharrow);
    patharrow.anchor = { x: 0, y: 0.5 };
    patharrow.visible = false;
    this.container.addChild(patharrow);

    this.dodrawpaths = true;

    // get some physics constants
    this.sanddrag = app.config.phys.drag.sand;
    this.airdrag = app.config.phys.drag.air;
    this.icedrag = app.config.phys.drag.ice;
  };

  p.hide=function() {
  	this.container.visible=false;
  };
    p.show=function() {
  	this.container.visible=true;
  };

  p.setsize = function(framein) {
    if (!framein) {
      frame = framein;
    } else {
      frame = app.config.gameoptions.rinkframe;
    }
    center = new Point(frame.x + frame.w / 2, frame.y + frame.h / 2);
  };

  p.clearlevel = function() {
    this.targetvictory.visible = false;
    for (var wo in worldobjects) {
      phys.destroyObject(worldobjects[wo]);
      rend.removeObject(worldobjects[wo]);
    }

    // remove the walls also

    this.starsgot = 0;
    this.refresh();
    this.usertarget = null;
    worldobjects = [];
    groupedobjects = {};
    deadobjects = [];
    worldnames = {};
  };

  p.adjustpos = function(pos, flip, integer) {
    var pos2 = [0, 0];
    if (flip) {
      pos2[0] = pos[0] - frame.x;
      pos2[1] = pos[1] - frame.y;
    } else {
      pos2[0] = pos[0] + frame.x;
      pos2[1] = pos[1] + frame.y;
    }

    if (integer) {
      pos2[0] = Math.round(pos2[0]);
      pos2[1] = Math.round(pos2[1]);
    }
    return pos2;
  };

  p.rinkposobj = function(worldobject) {
    var p = worldobject.getvisualposition();
    return this.adjustpos([p.x, p.y], true, true);
  };

  p.screentoworld = function(pos) {
    var pos2 = [pos[0] - frame.x, pos[1] - frame.y];
    return pos2;
  };

  p.worldsetupfromlevel = function(level, retry) {
    var worldpieces = [];

    // start out putting in the walls, which are the same for all levels. (Should they be?)
    // actually, do the walls separately.

    // then put in this level's target, plushie, and penguins, bonuses, and holes
    worldpieces = worldpieces.concat([
      { id: "target", pos: this.adjustpos(level.target) },
      { id: "plushie", pos: this.adjustpos(level.plushie) }
    ]);

    var i, pos, rot;

    for (i in level.bonus) {
      pos = level.bonus[i];
      worldpieces.push({ id: "bonus", pos: this.adjustpos(pos) });
    }
    for (i in level.starguess) {
      pos = level.starguess[i];
      worldpieces.push({ id: "starguess", pos: this.adjustpos(pos) });
    }
    for (i in level.targetplace) {
      pos = level.targetplace[i];
      worldpieces.push({ id: "targetplace", pos: this.adjustpos(pos) });
    }

    for (i in level.holes) {
      pos = level.holes[i];
      worldpieces.push({ id: "icehole", pos: this.adjustpos(pos) });
    }

    for (i in level.sand) {
      pos = level.sand[i];
      worldpieces.push({ id: "sand", pos: this.adjustpos(pos) });
    }

    for (i in level.penguins) {
      rot = level.penguins[i][2] ? level.penguins[i][2] : 120 * Vector.DEG2RAD; // default rotation for penguin is 120 degrees
      pos = [level.penguins[i][0], level.penguins[i][1]];
      worldpieces.push({ id: "penguin", pos: this.adjustpos(pos), rot: rot });
    }

    for (i in level.movingpenguins) {
      var makepath = [];
      var thispeng = level.movingpenguins[i];
      pos = [thispeng.path[0][0], thispeng.path[0][1]];
      var addpath = null;
      var adjustedpath = [];
      for (var d in thispeng.path) {
        var newpoint = this.adjustpos([
          thispeng.path[d][0],
          thispeng.path[d][1]
        ]);
        adjustedpath.push(newpoint);
      }
      addpath = { path: adjustedpath };

      var mpos = { x: adjustedpath[0][0], y: adjustedpath[0][1] };
      var mpos2 = { x: adjustedpath[1][0], y: adjustedpath[1][1] };
      var fv = new Point(mpos2.x - mpos.x, mpos2.y - mpos.y);
      rot = Vector.getangle(fv);
      // set rotation - point at the first item
      worldpieces.push({
        id: "movingpenguin",
        pos: [mpos.x, mpos.y],
        rot: rot,
        special: addpath
      });
    }

    var goal = { type: "normal" };
    if (level.goal.type == "predict") {
      goal = level.goal;
    }

    var force = level.force ? level.force : 0;
    var shots = level.shots ? level.shots : app.config.gameoptions.shotlimit; // always 1 now?
    var lpos = this.adjustpos(level.launcher);
    var launcherinfo = {
      position: { x: lpos[0], y: lpos[1] },
      force: force,
      lockforce: level.lockforce,
      lockposition: level.lockposition
    };

    if (retry) {
      launcherinfo = {
        position: { x: launcher.position.x, y: launcher.position.y },
        force: this.forcelevel,
        lockforce: launcher.lockforce,
        lockposition: launcher.lockposition
      };
    }

    var levelset = {
      gamelayout: worldpieces,
      shots: shots,
      goal: goal,
      launcher: launcherinfo
    };

    if (level.bushes) {
      levelset.bushes = [];
      for (i in level.bushes) {
        pos = level.bushes[i];
        levelset.bushes.push(pos);
      }
    }

    return levelset;
  };

  p.setlevel = function(levelin, retry) {
    if (!levelin) return null;

    level = levelin;
    // if it's a retry, don't change the user things - launcher position, tool, and force

    this.stopsim();
    this.history = [];
    this.clearlevel();
    block = null;

    stasis = true;
    noshot = true;
    stoppredicting = false;

    phys.events.off("collide", this.collision);
    phys.events.off("sense", this.sense);
    phys.events.off("stopsense", this.stopsense);
    shotstaken = 0;
    shot = -1;

    var worldsetup = this.worldsetupfromlevel(level, retry); // [[id,config,pos,vel]],[launcher.position.x,launcher.position.y,forcelevel]

    this.startfromstate(worldsetup);
    this.events.trigger("setforce", this.forcelevel);

    this.shotstatus = {
      force: 0,
      launcherpos: [],
      stars: null,
      targetpicked: null,
      fish: {
        obstacles: [],
        icehole: false
      },
      plushie: {
        target: false,
        obstacles: [],
        icehole: false,
        moved: false
      }
    };

    this.reload();

    this.refresh();

    phys.events.on("collide", this.collision);
    phys.events.on("sense", this.sense);
    phys.events.on("stopsense", this.stopsense);

    this.startsim();

    this.aim(true);

    if (gamesettings.goal.type === "predict") {
      this.parent.hideguidebutton();
    } else {
      this.parent.showguidebutton();
    }

    return level;
  };

  p.addbush = function(pos) {
    var adjustedpos = this.adjustpos(pos);
    var bush = this.placeitem("bush", adjustedpos);
    bush.vis.anchor = new Point(0.5, 0.5);
    if (!block) {
      block = {};
    }
    bush.vis.position = new Point(adjustedpos[0], adjustedpos[1]);

    // put the bush in block left, right, top, or bottom depending
    if (pos[0] <= 0) {
      // left wall
      if (!block.left) {
        block.left = [];
      }
      block.left.push(pos[1]);
    } else if (pos[0] >= frame.w) {
      // right wall
      if (!block.right) {
        block.right = [];
      }
      block.right.push(pos[1]);
    } else if (pos[1] <= 0) {
      // top
      if (!block.top) {
        block.top = [];
      }
      block.top.push(pos[0]);
    } else if (pos[1] >= frame.h) {
      // bottom
      if (!block.bottom) {
        block.bottom = [];
      }
      block.bottom.push(pos[0]);
    }
    return bush;
  };

  p.thumbnailfromstate = function(worldsetup) {
    var c = new Container();
    var nextitem;

    var icebg = this.getsprite(app.config.items.icebg, [
      frame.x + frame.w / 2,
      frame.y + frame.h / 2
    ]);
    c.addChild(icebg);
    var o, obj;

    for (o in worldsetup.gamelayout) {
      obj = worldsetup.gamelayout[o];
      var conf;
      if (obj.obj) {
        if (obj.obj.type === "wall") {
          continue;
        }

        nextitem = this.getsprite(obj.obj.config, obj.pos, obj.rot);
        nextitem.id = obj.obj.id;
      } else {
        nextitem = this.getsprite(app.config.items[obj.id], obj.pos, obj.rot);
        nextitem.id = obj.id;
      }

      // something special to represent moving penguins?
      if (nextitem) {
        if (nextitem.id === "movingpenguin") {
          // add penguin path
          var path = this.getpath(obj.special.path);
          c.addChild(path);
        }

        c.addChild(nextitem);
      }

      if (obj.id === "target" && worldsetup.goal.type === "predict") {
        nextitem.visible = false;
      }
    }

    for (o in worldsetup.bushes) {
      obj = this.adjustpos(worldsetup.bushes[o]);

      nextitem = this.getsprite(app.config.items.bush, obj);

      if (nextitem) {
        c.addChild(nextitem);
      }
    }
    return c;
  };

  p.getsprite = function(config, pos, rot) {
    var spr = new Sprite(images[config.image]);
    var newpos = this.adjustpos(pos, true); //
    spr.position = { x: newpos[0], y: newpos[1] };
    spr.anchor = { x: 0.5, y: 0.5 };
    if (rot) {
      spr.rotation = rot;
    }
    return spr;
  };

  p.getpath = function(patharray) {
    // create a graphics object with a line for the path
    var gr = new Graphics();
    gr.lineStyle(
      app.config.gameoptions.penguinpath.size,
      UIPanel.colorfromhex(app.config.gameoptions.penguinpath.color),
      app.config.gameoptions.penguinpath.alpha
    );
    var adj = this.adjustpos(patharray[0], true);
    gr.moveTo(adj[0], adj[1]);
    for (var p in patharray) {
      if (p > 0) {
        adj = this.adjustpos(patharray[p], true);
        gr.lineTo(adj[0], adj[1]);
      }
    }
    return gr;
  };

  p.wheresplushie = function() {
    var plpos = this.plushie.getvisualposition();
    return this.adjustpos([plpos.x, plpos.y], true);
  };
  
  p.getstars = function() {
    // get the display objects for stars for prediction rounds, so Ruff can point to them
    var starset=[];
    for(var ob in worldobjects) {
    	if(worldobjects[ob].type==="star") {
    		starset.push(worldobjects[ob]);
    	}
    }
    return starset;
  };
  
  p.gettargets = function() {
    // get any display objects for targets for prediction rounds, so Ruff can point to them
    var targetset=[];
    for(var ob in worldobjects) {
    	if(worldobjects[ob].id==="targetplace") {
    		targetset.push(worldobjects[ob]);
    	}
    }
    return targetset;
    };

  p.startfromstate = function(worldsetup) {
    this.clearlevel();

    /* worldsetup object has 'gamelayout' the list of objects, 'launcher' the launcher information (position and power) */

    gamesettings = {};

    gamesettings.shotlimit = worldsetup.shots;
    gamesettings.launcher = {};

    for (var s in worldsetup.launcher) {
      gamesettings.launcher[s] = worldsetup.launcher[s];
    }

    var wo;

    // create the walls; same for each level.
    // wall code

    var wallwidth = app.config.gameoptions.wallwidth;

    var leftwall = app.config.items.wall.clone();
    leftwall.physics.forms[0] = leftwall.physics.forms[0].clone();
    leftwall.physics.forms[0].size = [wallwidth * 2, frame.h];
    var pos = [frame.x - wallwidth, frame.y + frame.h / 2];

    wo = this.addtoworld("leftwall", leftwall, pos);
    wo.type = "wall";
    wo.nomove = true;

    var rightwall = leftwall.clone();
    pos = [frame.x + frame.w + wallwidth, frame.y + frame.h / 2];

    wo = this.addtoworld("rightwall", rightwall, pos);
    wo.type = "wall";
    wo.nomove = true;

    var topwall = leftwall.clone();
    topwall.image="wallruler";
    topwall.physics.forms[0] = topwall.physics.forms[0].clone();
    topwall.physics.forms[0].size = [frame.w, wallwidth * 2];
    pos = [frame.x + frame.w / 2, frame.y - wallwidth];

    wo = this.addtoworld("topwall", topwall, pos);
    wo.type = "wall";
    wo.nomove = true;

    var bottomwall = topwall.clone();
    pos = [frame.x + frame.w / 2, frame.y + frame.h + wallwidth];

    wo = this.addtoworld("bottomwall", bottomwall, pos);
    wo.type = "wall";
    wo.nomove = true;

    var penguinsprites = [];
    this.alwaysupdate = false;

    for (var c in worldsetup.gamelayout) {
      var obj = worldsetup.gamelayout[c];

      if (obj.obj) {
        if (obj.obj.type === "wall") {
          continue;
        }

        wo = this.addtoworld(obj.id, obj.obj.config, obj.pos, obj.rot, obj.vel); // id, , position, rotation
      } else {
        wo = this.placeitem(obj.id, obj.pos, obj.rot);
      }
      if (wo.id == "target") {
        this.target = wo;
        this.targetvictory.position = this.target.vis.position;
      }
      if (wo.id == "plushie") {
        this.plushie = wo;
        aimtarget = this.plushie;
      }

      if (wo.id == "starguess") {
        wo.type = "star";
        wo.starpicked = false;
        wo.activate(this.togglestar);
      }
      if (wo.id == "bonus") {
        wo.type = "star";
      }
      if (wo.id == "targetplace") {
        wo.activate(this.placetarget);
      }

      if (wo.id == "movingpenguin") {
        this.alwaysupdate = true;

        // this may have a path
        wo.vis.setframerate(12);
        wo.vis.loop = true;
        wo.vis.stopped = false;
        if (obj.obj && obj.obj.special) {
          wo.special = obj.obj.special;
        }

        if (obj.special) {
          wo.special = obj.special;
        }
        if (wo.special) {
          wo.path = wo.special.path;
          wo.pathstep = 0;
        }
        wo.stopchasing(true);
        if (obj.obj && obj.obj.savepathstep !== null) {
          wo.pathstep = obj.obj.savepathstep;
          wo.startwander();
        } else {
          var point = new Point(wo.path[1][0], wo.path[1][1]);
          wo.turntoface(point); // face the first position
        }

        penguinsprites.push(wo.vis);
      }

      if (wo.id == "penguin") {
        penguinsprites.push(wo.vis);
      }
    }

    for (var bush in worldsetup.bushes) {
      this.addbush(worldsetup.bushes[bush]);
    }

    // move the launcher back
    launcher.position.x = gamesettings.launcher.position.x;
    launcher.position.y = gamesettings.launcher.position.y;
    launcher.rotation = 0;
    launcher.lockforce = gamesettings.launcher.lockforce;
    launcher.lockposition = gamesettings.launcher.lockposition;

    this.forcelevel = gamesettings.launcher.force; // saved as scale of 1-10

    this.container.setChildIndex(
      this.target.vis,
      this.container.getChildIndex(this.panel.items.iceshine)
    ); // target near the bottom, but over a few things...
    rend.setdrawlayer(this.target); // ?
    this.container.setChildIndex(
      this.plushie.vis,
      this.container.children.length - 1
    ); // plushie above most....but should go under the penguins

    for (var p in penguinsprites) {
      this.container.setChildIndex(
        penguinsprites[p],
        this.container.children.length - 1
      );
    }

    this.container.setChildIndex(launcher, this.container.children.length - 1);

    gamesettings.goal = {};

    if (worldsetup.goal.type == "predict") {
      this.target.show(false);
      gamesettings.goal.type = "predict";
      if (worldsetup.goal.config == "target") {
        predict = true;
        this.target.hide();
        gamesettings.goal.config = "target";
      } else if (worldsetup.goal.config == "stars") {
        predict = false;
        gamesettings.goal.config = "stars";
      }
    } else {
      predict = false;
      gamesettings.goal.type = "normal";
      this.target.show();
    }

    return worldsetup;
  };

  p.clearstars = function() {
    for(var wo in worldobjects) {
      if(worldobjects[wo].type=='star') {
        this.selectstar(worldobjects[wo],false);
      }
    }
  };

  p.togglestar = function(ev) {
    if (stoppredicting) return;
    var thisstar = ev.target.wo;
    this.selectstar(thisstar,!thisstar.starpicked);
  };
  
  p.selectstar = function(starobj,turnon) {
  	starobj.userchanged=true;
    starobj.starpicked = turnon;
    var newimage = turnon ? "star" : "staroutline";
    starobj.changeimage(newimage);
    starobj.id = turnon ? "bonus" : "starguess";
  };
  
  p.getObjectAtPos = function(posin) { // position is rink position
    for(var wo in worldobjects) {
      var pos = worldobjects[wo].getvisualposition();
      pos=this.adjustpos([pos.x,pos.y],true,true);
      if(pos[0]==posin[0] && pos[1]==posin[1]) {
        return worldobjects[wo];
      }
    }
    
    return null;
  };

  p.placetarget = function(ev) {
    if (stoppredicting) return;
   // var thistarget = ev.target.wo;
    this.selecttarget(ev.target.wo,ev);
  };
  
  p.selecttarget=function(thistarget,ev) {
    var pos = thistarget.getworldposition();

    if (this.target.userchoice) this.target.userchoice.show();
    this.target.setworldposition(pos.x, pos.y);
    thistarget.hide();
    this.target.userchoice = thistarget;
    this.target.show();
    this.usertarget = this.target;

    this.targetvictory.position = this.target.vis.position;

    this.parent.enableshot();

    this.refresh();
    pos = this.adjustpos(
      [this.target.vis.position.x, this.target.vis.position.y],
      true,
      true
    );
    this.parent.chosetarget(pos, [ev.data.global.x, ev.data.global.y]);
    this.shotstatus.targetpicked = pos;
  };

  p.configfromstate = function(worldsetup) {
    /* 
		config for a state looks like
		
		 "hint":"Throw fish at the Plushie to PUSH it to the target. Set the level of FORCE to use for each throw.",
		 "tools":["fish","ice","snow"],
		 "stars":[1,3,8],
		 
		 "plushie":[550,240],
		 "launcher":[200,340],
		 "force":3,
		 
		 "goal":{
			"type":"predict",
			"config":["force",1],
			"c":2
			},
			
		 "target":[750,340],
		 
		 "bonus":[
		 	[300,200]
		 	],
	
		 "penguins":[
			{"path":[500,240]}
		]},
		 "holes":[[260,300]]
		*/

    var lp = this.adjustpos(
      [worldsetup.launcher.position.x, worldsetup.launcher.position.y],
      true
    );
    // user created level

    var levelconfig = {
      force: worldsetup.launcher.force,
      goal: gamesettings.goal,
      lockforce: gamesettings.launcher.lockforce,
      lockposition: gamesettings.launcher.lockposition
    };

    levelconfig.launcher = [
      Math.round(lp[0]),
      Math.round(lp[1]),
      worldsetup.launcher.force
    ];

    for (var c in worldsetup.gamelayout) {
      // convert all of the world values to display values
      //  look for penguins, plushie, target, and launcher. Launcher rotation will be automatic after placement. Also save force.

      var obj = worldsetup.gamelayout[c];
      var id = obj.id;
      var pos = this.adjustpos(
        [Math.round(obj.pos[0]), Math.round(obj.pos[1])],
        true
      );

      if (id == "penguin") {
        // add position to the penguins array
        if (!levelconfig.penguins) {
          levelconfig.penguins = [];
        }
        levelconfig.penguins.push(pos);
      }
      if (id == "movingpenguin") {
        // add position to the movingpenguins array
        if (!levelconfig.movingpenguins) {
          levelconfig.movingpenguins = [];
        }
        var patharray = [];
        if (obj.obj && obj.obj.special) {
          for (var pathpos in obj.obj.special.path) {
            patharray.push(
              this.adjustpos(obj.obj.special.path[pathpos], true, true)
            );
          }
        }
        if (patharray.length < 1) {
          patharray = [pos];
        }
        patharray[0][2] = obj.obj.rotation;
        levelconfig.movingpenguins.push({ path: patharray });
      } else if (id == "plushie") {
        levelconfig.plushie = pos;
      } else if (id == "target") {
        levelconfig.target = pos;
      } else if (id == "bonus") {
        if (!levelconfig.bonus) {
          levelconfig.bonus = [];
        }
        levelconfig.bonus.push(pos);
      } else if (id == "icehole") {
        if (!levelconfig.holes) {
          levelconfig.holes = [];
        }
        levelconfig.holes.push(pos);
      } else if (obj.obj && obj.obj.type == "star") {
        if (!levelconfig[id]) {
          levelconfig[id] = [];
        }
        levelconfig[id].push(pos);
      } else if (id == "sand") {
        if (!levelconfig.sand) {
          levelconfig.sand = [];
        }
        levelconfig.sand.push(pos);
      } else if (id == "bush") {
        if (!levelconfig.bushes) {
          levelconfig.bushes = [];
        }
        levelconfig.bushes.push(pos);
      } else if (id == "targetplace") {
        if (!levelconfig.targetplace) {
          levelconfig.targetplace = [];
        }
        levelconfig.targetplace.push(pos);
      } else if (id == "starguess") {
        if (!levelconfig.starguess) {
          levelconfig.starguess = [];
        }
        levelconfig.starguess.push(pos);
      }
    }

    levelconfig.id = this.gameidfromconfig(levelconfig);

    return levelconfig;
  };

  p.getgamesettings = function() {
    return gamesettings;
  };

  p.setgametype = function(type) {
    switch (type) {
      case "predict":
        gamesettings.goal = { type: "predict", config: "target" };
        break;

      case "normal":
        gamesettings.goal = { type: "normal" };
        break;

      case "stars":
        gamesettings.goal = { type: "predict", config: "stars" };
        break;
    }
  };

  p.setlauncherlock = function(yesorno) {
    launcher.lockposition = yesorno;
    gamesettings.launcher.lockposition = launcher.lockposition;
  };

  p.setsliderlock = function(yesorno) {
    launcher.lockforce = yesorno;
    gamesettings.launcher.lockforce = launcher.lockforce;
  };

  p.gameidfromconfig = function(config) {
    // for challenges, count the number of penguins, ice holes, sand traps, moving penguins and bonuses, and return chal_pg#_ih#_sd#_mp#_bn#

    // for prediction (targets), add the number (and position?) of targets or stars: pred_pg#_ih#_sd#_mp#_bn#_tg# or pred_pg#_ih#_sd#_mp#_st#

    var nums = {
      sand: 0,
      holes: 0,
      bonus: 0,
      starguess: 0,
      penguins: 0,
      movingpenguins: 0,
      targetplace: 0
    };
    for (var thing in config) {
      if (nums[thing] !== undefined) {
        for (var count in config[thing]) {
          nums[thing]++;
        }
      }
    }

    /* in the final list, there will be index numbers appended to the end to differentiate. 
		
		There's also a code of sorts: 
		F=Force only (launcher is locked, no moving penguins)
		P=Position only (slider is locked, no moving penguins)
		FP=Force and Position (no locks, no moving penguins)
		T=Timing only (launcher is locked, slider is locked, moving penguins)
		FT=Force and Timing (launcher is locked, moving penguins)
		PT=Position and Timing (launcher is locked, moving penguins)
		FPT=Force, position, timing (no locks, moving penguins)
		
		*/

    var lookup = {
      // looks up whether Force, Position, or Timing are needed, in that order
      NNN: "_X",
      YNN: "_F",
      NYN: "_P",
      YYN: "_FP",
      NNY: "_T",
      YNY: "_FT",
      NYY: "_PT",
      YYY: "_FPT"
    };

    var changeforce = config.lockforce ? "N" : "Y";
    var changeposition = config.lockposition ? "N" : "Y";
    var changetiming = nums.movingpenguins > 0 ? "Y" : "N";

    var code = changeforce + changeposition + changetiming;

    var addcode = lookup[code];

    var base =
      "pg" +
      nums.penguins +
      "_sd" +
      nums.sand +
      "_mp" +
      nums.movingpenguins +
      "_ih" +
      nums.holes;

    //_tgt# and _st#
    if (config.goal.type === "predict") {
      var add = "";
      if (nums.targetplace) {
        add += "tgt" + nums.targetplace + "_";
      }
      if (nums.starguess) {
        add += "st" + nums.starguess + "_";
      }
      return "pred_" + add + base + addcode;
    } else {
      if (nums.bonus) {
        base += "_bn" + nums.bonus;
      }
      return "chal_" + base + addcode;
    }
  };

  p.getlockedforce = function() {
    if(gamesettings.launcher) {
      return gamesettings.launcher.lockforce;
    }
    return true;
  };

  p.getlockedposition = function() {
    if(gamesettings.launcher) {
      return gamesettings.launcher.lockposition;
    }
    return true;
  };

  p.draggabletarget = function() {
    if (!this.target) return;
    this.target.vis.interactive = true;
    this.target.vis.off(app.taptype, this.dragtarget);
    this.target.vis.on(app.taptype, this.dragtarget);
  };

  p.dragtarget = function(ev) {
    if (shotstaken > 0) return;
    this.noplay();

    this.container.off(app.dragtype, this.movetarget);
    this.container.off(app.releasetype, this.droptarget);
    this.container.on(app.dragtype, this.movetarget);
    this.container.on(app.releasetype, this.droptarget);
  };

  p.movetarget = function(ev) {
    var newx =
      (ev.data.global.x - this.container.position.x) / this.container.scale.x;
    var newy =
      (ev.data.global.y - this.container.position.y) / this.container.scale.y;
    this.target.setvisualposition(newx, newy, 0);
  };

  p.converttappos = function(ev) {
    return this.localpos({ x: ev.data.global.x, y: ev.data.global.y });
  };

  p.localpos = function(pos) {
    var newx = (pos.x - this.container.position.x) / this.container.scale.x;
    var newy = (pos.y - this.container.position.y) / this.container.scale.y;
    return { x: newx, y: newy };
  };

  p.globalpos = function(pos) {
    var newx = (pos.x + this.container.position.x) * this.container.scale.x;
    var newy = (pos.y + this.container.position.y) * this.container.scale.y;
    return { x: newx, y: newy };
  };

  p.rinkpos = function(pos) {
    var newpos = this.adjustpos([pos.x, pos.y], true, true);
    return { x: newpos[0], y: newpos[1] };
  };

  p.droptarget = function(ev) {
    this.noplay(false);
    this.target.matchbodypositiontovisual();
    this.container.off(app.dragtype, this.movetarget);
    this.container.off(app.releasetype, this.droptarget);
  };

  p.dragitem = function(ev) {
    this.noplay();

    var tpo = this.converttappos(ev);

    var dro = {
      x: ev.target.position.x - tpo.x,
      y: ev.target.position.y - tpo.y
    };

    this.dragoffset = dro;
    this.dragging = ev.target.wo;
    if (this.dragging.id === "penguin" && !this.dragging.rotation) {
   //   this.dragging.setrotation(120 * Vector.DEG2RAD, true);
    }
    if (this.dragging.config.dragimage) {
      this.dragging.changeimage(this.dragging.config.dragimage);
    }
    
    if(this.dragging.id === "movingpenguin") { // TODO: make an outlined version of moving penguin. It's complicated because penguin is a flipbook
    // UIPanel.settoAtlasFrameNumber(this.dragging.vis.sprite,app.config.spritesheets.penguinmove,3);
    //this.dragging.changevisual(new Sprite(images[this.dragging.config.swapimage]));
    }
    
    var gvp = this.dragging.getvisualposition();
    this.dragging.snapback = { x: gvp.x, y: gvp.y };
    this.container.off(app.dragtype, this.moveitem);
    this.container.off(app.releasetype, this.dropitem);
    this.container.on(app.dragtype, this.moveitem);
    this.container.on(app.releasetype, this.dropitem);

    this.parent.dragitem(ev.target.wo, ev);
  };

  p.moveitem = function(ev) {
    var pos = this.converttappos(ev);

    this.dragging.setvisualposition(
      pos.x + this.dragoffset.x,
      pos.y + this.dragoffset.y,
      this.dragging.rotation
    );
    rend.update();

    if (this.editmode) {
      this.aim();
    }

    if (!this.checkinrink(pos)) {
      this.dragging.setalpha(0.5);
    } else {
      this.dragging.setalpha(1);
    }
    var plook;
    if (this.dragging.special && this.dragging.special.path) {
      plook = {
        x: this.dragging.special.path[1][0],
        y: this.dragging.special.path[1][1]
      }; // penguin should face its first path point
      this.dragging.turntoface(plook, true);
      this.updatepenguinpaths();
    } else if (
      this.dragging.id === "penguinpathpoint" &&
      this.dragging.whatpoint.index === 1
    ) {
      plook = { x: pos.x + this.dragoffset.x, y: pos.y + this.dragoffset.y };
      var penguin = this.dragging.whatpoint.obj;
      penguin.turntoface(plook);
      this.updatepenguinpaths();
    }
  };

  p.updatepenguinpaths = function() {
    rend.drawline(this.penguinpathlayer, false);
    for (var wo in worldobjects) {
      if (worldobjects[wo].id === "penguinpathpoint") {
        //gr,noclear,pointa,pointb,size,color,alpha

        var startpos = [
          worldobjects[wo].vis.position.x,
          worldobjects[wo].vis.position.y
        ];
        var endpos = [
          worldobjects[wo].whatpoint.obj.vis.position.x,
          worldobjects[wo].whatpoint.obj.vis.position.y
        ];
        rend.drawline(
          this.penguinpathlayer,
          true,
          { x: startpos[0], y: startpos[1] },
          { x: endpos[0], y: endpos[1] },
          app.config.gameoptions.penguinpath.size,
          app.config.gameoptions.penguinpath.color,
          app.config.gameoptions.penguinpath.alpha
        );
      }
    }
  };

  p.dropitem = function(ev) {
    this.container.off(app.dragtype, this.moveitem);
    this.container.off(app.releasetype, this.dropitem);
    this.noplay(false);
    var pos = this.converttappos(ev);
    var inrink = false;
    var remove = false;
    pos.x += this.dragoffset.x;
    pos.y += this.dragoffset.y;
    // also lock it to integer pixels, because it will be saved that way and don't want little variations
    pos.x = Math.round(pos.x);
    pos.y = Math.round(pos.y);

    if (this.checkinrink(pos)) {
      var spot, newpos;
      inrink = true;
      
      /* TODO: STILL trying to determine whether to change on drop or not
      if (this.dragging.id !== "movingpenguin") {
        this.dragging.changeimage(this.dragging.config.image);
      }
      */
      
      if (this.dragging.id === "bush") {
        // lock bush to left/right/top/bottom
        var closestwall = "";
        var closedist = 10000;
        var pos2 = this.adjustpos([pos.x, pos.y], true);
        var newdist = pos2[0];
        if (newdist < closedist) {
          closestwall = "left";
          closedist = newdist;
        }
        newdist = frame.w - pos2[0];
        if (newdist < closedist) {
          closestwall = "right";
          closedist = newdist;
        }
        newdist = frame.h - pos2[1];
        if (newdist < closedist) {
          closestwall = "bottom";
          closedist = newdist;
        }
        newdist = pos2[1];
        if (newdist < closedist) {
          closestwall = "top";
          closedist = newdist;
        }
        var lock = [];
        switch (closestwall) {
          case "left":
            lock = [0, pos2[1]];
            break;
          case "right":
            lock = [frame.w, pos2[1]];
            break;

          case "bottom":
            lock = [pos2[0], frame.h];
            break;

          case "top":
            lock = [pos2[0], 0];
            break;
        }
        lock = this.adjustpos(lock);
        this.dragging.vis.position = { x: lock[0], y: lock[1] };
        this.dragging.matchbodypositiontovisual();
        return;
      }

      this.dragging.setvisualposition(pos.x, pos.y);
      if (this.dragging.id === "movingpenguin") {
        // should be able to SLIDE to a point, or just PLACE a point until....what?
        this.dragging.pathstep = 0;
        if (!this.dragging.special) {
          this.dragging.special = { path: null };
          var movelength=app.config.gameoptions.penguinmovelength;
          var dcenter=new Point(center.x-pos.x,center.y-pos.y);// move toward the center, to keep it from walking off the rink.
          dcenter.normalize();
          newpos = [pos.x + movelength*dcenter.x, pos.y + movelength*dcenter.y]; 
    	  var rot = Vector.getangle(dcenter);
          this.dragging.special.path = [1, newpos];
          spot = this.placeitem("penguinpathpoint", newpos);
          spot.activate(this.dragitem);
          spot.type = "editonly";
          spot.whatpoint = { obj: this.dragging, index: 1 };
          this.dragging.setrotation(rot);
        }
        this.dragging.special.path[0] = [pos.x, pos.y];
        this.updatepenguinpaths();
      } else if (this.dragging.id == "penguinpathpoint") {
        // maybe add a new point?

        var whatpoint = this.dragging.whatpoint;
        /* TODO: add more penguin points
				if(whatpoint.index==whatpoint.obj.special.path.length-1) {
					var newindex=whatpoint.index+1;
					newpos=[pos.x-50,pos.y+50];
					spot=this.placeitem('penguinpathpoint',newpos);
					spot.activate(this.dragitem);
					spot.type="editonly";
					whatpoint.obj.special.path.push(newpos);
					spot.whatpoint={'obj':whatpoint.obj,'index':newindex};
				}
*/
        whatpoint.obj.special.path[whatpoint.index] = [pos.x, pos.y];
      }
    } else {
      // dropped outside of rink
      if (this.dragging.id == "target" || this.dragging.id == "plushie") {
        this.dragging.setvisualposition(
          this.dragging.snapback.x,
          this.dragging.snapback.y
        );

        this.dragging.setalpha(1);
        if(this.dragging.id == "plushie") { this.aim(); }
      } else if (this.dragging.id == "penguinpathpoint") {
        // snap back somewhere?
        var ind = this.dragging.whatpoint.index;
        if (ind === 1) {
          this.dragging.setvisualposition(
            this.dragging.snapback.x,
            this.dragging.snapback.y
          );

          this.dragging.whatpoint.obj.special.path[ind] = [
            this.dragging.snapback.x,
            this.dragging.snapback.y
          ];

          this.dragging.setalpha(1);
          var plook = {
            x: this.dragging.snapback.x,
            y: this.dragging.snapback.y
          };
          var penguin = this.dragging.whatpoint.obj;
          penguin.turntoface(plook);
        } else {
          // move out this index and pull in everything after it
          this.dragging.whatpoint.obj.special.path.splice(ind, 1);
          this.removeitem(this.dragging, true);
          remove = true;
        }
        this.updatepenguinpaths();
      } else {
        if (this.dragging.id === "movingpenguin") {
          // also remove the target spots

          for (var o in worldobjects) {
            if (
              worldobjects[o].id === "penguinpathpoint" &&
              worldobjects[o].whatpoint.obj === this.dragging
            ) {
              this.removeitem(worldobjects[o], true);
            }
          }

          // and the connecting line
          this.updatepenguinpaths();
        }
        this.removeitem(this.dragging, true);
        remove = true;
      }
    }

    rend.update();
    phys.update(1);

    this.parent.dropitem(
      this.dragging,
      inrink,
      remove,
      pos,
      this.dragging.isnew
    );

    if (this.guideon) {
      this.showguide();
    }

    this.dragging.isnew = false;
  };

  p.checkinrink = function(pos) {
    return (
      pos.x > frame.x &&
      pos.x < frame.x + frame.w &&
      pos.y > frame.y &&
      pos.y < frame.y + frame.h
    );
  };

  p.placeitem = function(id, pos, rot) {
    var obj = app.config.items[id];
    var wo = this.addtoworld(id, obj, pos, rot);
    return wo;
  };

  p.removeallid = function(id) {
    for (var o in worldobjects) {
      if (worldobjects[o].id === id) {
        this.removeitem(worldobjects[o]);
      }
    }
    this.refresh();
  };

  p.startpenguinpath = function(obj) {};

  p.endpenguinpath = function() {};

  p.addpenguinpathpoint = function(pos) {};

  p.setname = function(obj) {
    // find a unique name based on this id
    var suffix = 1;
    var tryname = obj.id + "_" + suffix;
    //		var limit=100;
    while (worldnames[tryname]) {
      suffix++;
      tryname = obj.id + "_" + suffix;
    }
    worldnames[tryname] = obj;
    obj.setname(tryname);
    return tryname;
  };

  p.addtoworld = function(id, obj, pos, rot, vel) {
    if (!pos) {
      pos = obj.pos;
    }

    if (!obj) return null;

    if (!id) {
      id = obj.id;
    }

    if (!rot) rot = 0;

    var settings = {
      position: pos,
      rotation: rot,
      type: obj.physics.type
    };

    for (var op in obj.physics.settings) {
      settings[op] = obj.physics.settings[op];
    }

    var wo = new WorldObject({
      id: id,
      physicsmanager: phys,
      physicsrenderer: rend,
      settings: settings,
      config: obj
    });

    worldobjects.push(wo);
    if(!groupedobjects[id]) {
	    groupedobjects[id]=[];
    }
    groupedobjects[id].push(wo);
    phys.addObjectToWorld(wo);

    rend.addObjectToDisplay(wo, null, {
      x: pos[0],
      y: pos[1],
      rotation: pos[2]
    });
    if (vel) {
      wo.setworldvelocity(vel[0], vel[1], vel[2]);
    }
    this.setname(wo);
    return wo;
  };

  p.showlayout = function() {
    var wstate = phys.savescaledworldstate();
    var l = {
      gamelayout: wstate,
      goal: gamesettings.goal,
      launcher: this.getlauncherspec()
    };
    return this.configfromstate(l);
  };

  p.setplaymode = function(mode) {
    // play or replay mode
    switch (mode) {
      case "replay":
        playmode = "replay";
        this.stopsim();
        break;

      case "play":
        playmode = "play";
        this.clearpaths();
        if (this.alwaysupdate) {
          this.startsim();
        }
        break;
    }
  };

  p.storeit = function(key, obj) {
    var serialized = JSON.stringify(obj);
    localStorage.setItem(key, serialized);
  };

  p.fetchit = function(key) {
    return JSON.parse(localStorage.getItem(key));
  };

  p.clearpaths = function() {
    rend.cleardrawing();
    patharrow.visible = false;
  };

  p.drawpaths = function(framenum, arrow) {
    // draw full path up to this point, for scrubber. May prove too taxing on slow devices
    if (lastdrawnframe > framenum) {
      rend.cleardrawing();
      patharrow.visible = false;
      lastdrawnframe = 0;
    }
    if (!this.dodrawpaths && !this.dodrawdistance) return;
    var v, t, d;
    var endpos,lastfish;
    var hitplushie = false;

    for (var w in this.history[shot].steps) {
      // skip the penguins?
      var thisshot = this.history[shot].steps[w];
      var last = Math.min(framenum + 1, thisshot.length - 10);
      var wo = worldnames[w];
      var totaldistance = 0;
      var lastpos = [thisshot[0][0], thisshot[0][1]];
      for (t = lastdrawnframe + 1; t < last; t++) {
        var pos = thisshot[t - 1];
        var pos2 = thisshot[t];

        if (pos == "X") continue;

        if (pos === 0 && pos2 === 0) continue;

        if (wo.id == "fish" && !hitplushie && pos2) {
          endpos = [pos2[0], pos2[1], pos[0], pos[1]];
          lastfish=[pos2[0],pos2[1]];
        }

        if (wo == this.plushie) {
          if (pos2) {
            lastpos = [pos2[0], pos2[1]];
            v = new Point(pos2[0] - pos[0], pos2[1] - pos[1]);

            totaldistance += v.length();

            hitplushie = true;
            if(!pos) { // fish only JUST hit the plushie
            	endpos = [pos2[0], pos2[1], lastfish[0], lastfish[1]];
            } else {
            	endpos = [pos2[0], pos2[1], pos[0], pos[1]];
			}
          } else {
            lastpos = [pos[0], pos[1]];
          }

          if (t === 1) {
            rend.drawcircle(
              { x: pos[0], y: pos[1] },
              wo.radius() / 2,
              wo.pathcolor,
              false
            );
          }
        }

        if (this.dodrawpaths) {
          if (pos2[3] && this.editmode) {
            rend.drawcircle(
              { x: pos2[0], y: pos2[1] },
              wo.radius(),
              wo.pathcolor,
              true
            );
          }

          rend.drawpath(
            { x: pos[0], y: pos[1] },
            { x: pos2[0], y: pos2[1] },
            4,
            wo.pathcolor,
            0.75
          );
        }
      }

      if (wo == this.plushie && this.dodrawdistance) {
        rend.drawpath(
          { x: lastpos[0], y: lastpos[1] },
          { x: this.target.vis.position.x, y: this.target.vis.position.y },
          1,
          "#333333"
        );
      }
    }

    var addfish = hitplushie ? "" : "fish";

    if (this.editmode) {
      patharrow.anchor.x = 0.5;
      UIPanel.setimage(patharrow, images["pathendpoint" + addfish]);
    } else {
      patharrow.anchor.x = 0;
      UIPanel.setimage(patharrow, images["patharrow" + addfish]);
    }

    patharrow.visible = true;
    patharrow.position = { x: endpos[0], y: endpos[1] };
    var pt = new Point(endpos[0] - endpos[2], endpos[1] - endpos[3]);
    var rot = Vector.getangle(pt);
    patharrow.rotation = rot;

    lastdrawnframe = framenum;
  };

  p.sense = function(ev) {
    // sensory, not collision
    if (!(ev.n1 && ev.n2)) return;
    var match;
    match = this.getrelevantbody(ev.n1, ev.n2, "bonus");
    if (match && match[1].id == "plushie") {
      this.getstar(match[0]);
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "starguess");
    if (match && match[1].id == "plushie") {
      // plushie hit a star that user hadn't guess it would
      match[0].id = "starmissed";
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "sand");
    if (match) {
      match[1].insand = true;
      if(match[1].id == "plushie") {
      	this.shotstatus.plushie.hitsand=true;
      }
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "icehole");
    if (match) {
      match[1].nearhole = match[0];
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "target");
    if (match && match[1].id == "plushie") {
      this.shotstatus.plushie.target = true; // remember for the final shot status, in case plushie moves too far
      this.plushie.intarget = true;
    }
  };

  p.stopsense = function(ev) {
    if (!(ev.n1 && ev.n2)) return;
    var match;
    match = this.getrelevantbody(ev.n1, ev.n2, "icehole");
    if (match) {
      match[1].nearhole = null;
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "sand");
    if (match) {
      match[1].insand = false;
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "target");
    if (match && match[1].id == "plushie") {
      this.plushie.intarget = false;
    }
  };

  p.collision = function(ev) {
    if (!(ev.n1 && ev.n2)) return;

    // don't save collision if one is only a sensor.
    this.savecollision(ev.n1);
    this.savecollision(ev.n2);

    var fl, o; // decide which object is the key object to pay attention to

    var match;

    match = this.getrelevantbody(ev.n1, ev.n2, "plushie");
    if (match) {
      this.gamesound("bump");
      this.shotstatus.plushie.moved = true;
      this.shotstatus.plushie.obstacles.push({
        id: match[1].id,
        pos: this.rinkposobj(match[1]), // obstacle location
        pos2: this.rinkposobj(match[0]) // plushie location
      });

      if (match[1].id === "penguin") {
        // do something fun?
        var rot = match[1].getrotation();
        var ang = match[1].turntoface(match[0].getscaledworldposition());
        var dir = 1;
        if (ang < rot) {
          dir = -1;
        }
        match[1].spin(ang - rot, dir);
      }
    }

    match = this.getrelevantbody(ev.n1, ev.n2, "fish");
    if (match) {
      this.gamesound("littlebump");
      this.shotstatus.fish.obstacles.push(match[1]);
    }
  };

  p.getrelevantbody = function(body1, body2, idtomatch) {
    if (body1.id == idtomatch) {
      return [body1, body2];
    } else if (body2.id == idtomatch) {
      return [body2, body1];
    }
    return false;
  };

  p.removeitem = function(obj, now) {
    phys.destroyObject(obj); // get it out of the simulation
    obj.status = "dead";
    obj.show(false); // just hide it b/c it'll need to be back for replay... but really remove it on next shot

    if (now) {
      rend.removeObject(obj);
      for (var w in worldobjects) {
        if (worldobjects[w] == obj) {
          worldobjects.splice(w, 1);
          break;
        }
      }
      for(w in groupedobjects[obj.id]) {
      	if(groupedobjects[obj.id][w] == obj) {
      		groupedobjects[obj.id].splice(w, 1);
      		break;
      	}
      }
    }
    // don't remove from worldobjects until the next turn - save it for replay.
  };

  p.removealldeadobjects = function() {
  	var w,wl=worldobjects.length - 1;
  	
    for (w = wl; w >= 0; w--) {
      if (worldobjects[w].status === "dead") {
        rend.removeObject(worldobjects[w]);
        worldobjects.splice(w, 1);
      }
    }

    for(var id in groupedobjects) {
	    var grouparray=groupedobjects[id];
	    wl=grouparray.length -1;
	    for (w=wl; w>=0; w--) {
      	if(grouparray[w].status == "dead") {
      		grouparray.splice(w, 1);
      	}
      }
    }

    phys.removedestroyed();
  };

  p.setforcelevel = function(l) {
    this.forcelevel = l;
    if (this.guideon) {
      this.showguide();
    }
  };

  p.aim = function(force) {
    if (stasis && !force) {
      // no objects are moving, so if launcher isn't either, no change needed
      if (launcher.last.distance(launcher.position) === 0) {
        return false;
      }
    }

    launcher.aim.x = aimtarget.vis.position.x - launcher.position.x;
    launcher.aim.y = aimtarget.vis.position.y - launcher.position.y;
    launcher.angle = Vector.getangle(launcher.aim);
    launcher.rotation = launcher.angle;

    return true;
  };

  p.aimpenguins = function(lookat) {
    for (var w in worldobjects) {
      if (
        worldobjects[w].id == "penguin" ||
        worldobjects[w].id == "movingpenguin"
      ) {
        var obj = worldobjects[w];
        var pos = lookat.getvisualposition();
        obj.turntoface(lookat);
      }
    }
  };

  p.repeatshot = function() {
    this.stopsim();
    var worldsetup = this.history[shot].initial;
    this.startfromstate(worldsetup);
    this.events.trigger("setforce", this.forcelevel);
    this.aim(true);
  };

  p.stepphysics = function() {
    historyframe++;
    this.physupdate(t2);
  };

  p.endspeculation = function() {
    this.shotstatus = {
      force: 0,
      fish: {
        obstacles: [],
        icehole: false
      },
      plushie: {
        target: false,
        obstacles: [],
        icehole: false,
        moved: false
      }
    };
  };

  p.settestshot = function(force) {
    if (!force) {
      force = this.forcelevel;
    }

    shot = 0;
    historyframe = 0;
    this.history[shot] = { steps: {}, initial: {} };
    stasis = false;
    var physforce = minforce + (maxforce - minforce) * force / 10;

    this.getclosewalls();

    this.aim(true);
    launcher.aim.normalize();
    launcher.aim.scaleBy(5);

    var puck = this.placeitem(this.tooltype, [
      launcher.position.x + launcher.aim.x,
      launcher.position.y + launcher.aim.y
    ]);

    puck.recordposition();
    this.savepositionstohistory();

    phys.applyImpulse(puck, Vector.vecam(launcher.angle, physforce));
  };

  p.guideshot = function(partial) {
    if (this.editmode) {
      // hide any moving penguins and destination spots from the simulation in edit mode
      this.cleareditthings();
      for (var wo in worldobjects) {
        if (worldobjects[wo].id === "movingpenguin") {
          this.removeitem(worldobjects[wo]);
        }
      }
    } else {
      partial = true;
    }
    var endstate = this.completegamestate();
    this.settestshot();

    phys.events.off("collide", this.collision);
    phys.events.on("collide", this.collision);

    phys.events.off("sense", this.sense);
    phys.events.off("stopsense", this.stopsense);

    phys.events.on("sense", this.sense);
    phys.events.on("stopsense", this.stopsense);

    this.gountilstasis();

    var maxframes = 1;
    lastdrawnframe = 0;
    for (var rf in this.history[shot].steps) {
      var framecount = this.history[shot].steps[rf].length;
      if (framecount > maxframes) {
        maxframes = framecount;
      }
    }

    if (partial) {
      maxframes = parseInt(maxframes * 0.3);
    }

    phys.events.off("collide", this.collision);
    phys.events.off("sense", this.sense);
    phys.events.off("stopsense", this.stopsense);
    this.drawpaths(maxframes - 1);
    this.startfromstate(endstate);
    this.refresh();

    this.endspeculation();
    if (this.editmode) {
      this.editmode = false;
      this.startedit();
    }
    this.stopsim();
    this.aim(true);
  };

  p.gountilstasis = function() {
    this.stepphysics();
    if (!stasis) {
      this.gountilstasis(); // DANGER recursion!
    }
  };

  p.lastshot = function() {
    var worldsetup = this.history[shot].initial;
    this.startfromstate(worldsetup);
    physforce = maxforce;
  };

  p.gountiltarget = function() {
    this.stepphysics();
    var dc = this.intarget();
    var didhit;
    if (!stasis && !dc) {
      didhit = this.gountiltarget();
    } else {
      didhit = false;
      if (dc) {
        didhit = true;
      }
      // draw everything based on history
    }

    return didhit;
  };

  p.predictshot = function() {
    this.stopsim();

    var endstate = this.completegamestate();

    var worldsetup = this.history[shot].initial;
    this.startfromstate(worldsetup);

    this.settestshot(10);
    var result = this.gountiltarget();
    stasis = true;

    this.startfromstate(endstate);
    this.stopsim();
    this.aim(true);

    return result;
  };

  p.intarget = function() {
    var fp = this.plushie.getscaledworldposition();
    var tp = this.target.getscaledworldposition();
    var d = Math.distSq(fp.x, fp.y, tp.x, tp.y);
    var accuracy = 0;
    if (d < this.closest) {
      this.closest = d;
    }
    if (d < victorydistance.l) {
      accuracy = 1;
      if (d < victorydistance.m) {
        accuracy = 2;
        if (d < victorydistance.s) {
          accuracy = 3;
        }
      }
    }
    return accuracy;
  };

  p.getstar = function(obj) {
    obj.changeimage("starglow");
    this.gamesound("correct");

    if (!this.starsgot) {
      this.starsgot = 0;
    }
    this.starsgot++;
    obj.id = "stargot";
  };

  p.clearguide = function() {
    rend.cleardrawing();

    patharrow.visible = false;
    if (this.alwaysupdate && !this.editmode) {
      this.startsim();
    } else if (this.editmode) {
      // Should guide be available in edit mode?
    }
  };

  p.showguide = function() {
    // draw from here to first thing to hit, then draw from that thing
    // don't redraw anything if nothing has moved! check stasis and last position of launcher
    rend.cleardrawing();
    this.guideshot();
  };

  p.refresh = function(t) {
    if (!t) t = 1;
    phys.update(t);
    rend.update(t);
  };

  p.showpaths = function() {
    for (var w in worldobjects) {
      var obj = worldobjects[w];
      if (obj.lastpos && obj.speedsq() > 0.005) {
        var speed = Math.sqrt(obj.speedsq());
      }
    }
  };

  p.shootit = function(forcein) {
    if (this.notplaying || reloading) return false;

    if (forcein <= 0) {
      this.noforcealert();
      return false;
    }

    if (predict && !this.usertarget) {
      this.nopredictalert();
      return false;
    }

    this.forcelevel = forcein;

    phystick = normal;
    tracepaths = true;
    if (gamesettings.shotlimit - shotstaken <= 0) {
      return false;
    }

    this.startsim();
    collisionsounds = true;

    if (this.aim()) {
      // aim has moved recently...
    }

    rend.cleardrawing();

    this.beginnewshot();

    this.getclosewalls();

    this.closest = Math.distSq(
      this.plushie.vis.position.x,
      this.plushie.vis.position.y,
      this.target.vis.position.x,
      this.target.vis.position.y
    );

    this.shotstatus.force = this.forcelevel;
    this.shotstatus.launcherpos = [launcher.position.x, launcher.position.y];
    launcher.aim.normalize();
    launcher.aim.scaleBy(5);

    puck = this.placeitem(this.tooltype, [
      launcher.position.x + launcher.aim.x,
      launcher.position.y + launcher.aim.y
    ]);

    // forcein is 0-10, min to max. Convert to maxforce for the actual physics hit
    var physforce = minforce + (maxforce - minforce) * this.forcelevel / 10;
    puck.recordposition();
    phys.applyImpulse(puck, Vector.vecam(launcher.angle, physforce));

    this.events.on("stasis", this.checkvictory);
    return true;
  };

  p.reload = function() {
    if (gamesettings.shotlimit > shotstaken) {
      this.parent.reload();
      reloading = false;
    }
  };

  p.outofshots = function() {
    this.parent.outofshots();
  };

  p.draglauncher = function(clickpos) {
    // move launcher to follow mouse until mouseup
    if (this.notplaying) return;

    var tpo = this.localpos(clickpos);

    var dro = {
      x: launcher.position.x - tpo.x,
      y: launcher.position.y - tpo.y
    };

    this.dragoffset = dro;

    launcher.mayshoot = true;
    if (!launcher.lockposition || this.editmode) {
      this.container.on(app.dragtype, this.movelauncher);
    }
    this.container.on(app.releasetype, this.droplauncher);
    this.parent.panel.on(app.releasetype, this.droplauncher); // why two droplaunchers?
  };

  p.movelauncher = function(ev) {
    // compare to the center...

    var pos = this.converttappos(ev);

    var newx = pos.x + this.dragoffset.x;
    var newy = pos.y + this.dragoffset.y;

    launcher.mayshoot = false;
    if (
      (launcher.position.x - newx) * (launcher.position.x - newx) +
        (launcher.position.y - newy) * (launcher.position.y - newy) >
      launchertouch
    ) {
      // if too far from launcher, then drop the launcher rather than have it jump around?
      this.droplauncher();
      return;
    }

    this.putlauncher(newx, newy);
  };

  p.launchernearcorner = function() {
    if (
      Math.abs(center.x - launcher.position.x) > frame.w * 0.5 - 40 &&
      Math.abs(center.y - launcher.position.y) > frame.h * 0.5 - 40
    ) {
      return true;
    }
    return false;
  };

  p.placelauncher = function(x, y) {
    // actual launch placement, from level - not user moving
    var newpos = this.adjustpos([x, y]);
    launcher.position.x = newpos[0];
    launcher.position.y = newpos[1];
    var whichwall = this.launcherwall(newpos[0], newpos[1]);
    launcher.onwall = whichwall;
    this.aim();
  };

  p.launcherwall = function(newx, newy) {
    var closedist = 10000;
    var whichwall;
    var distcheck = Math.abs(frame.x - newx);
    if (distcheck < closedist) {
      whichwall = "left";
      closedist = distcheck;
    }
    distcheck = Math.abs(frame.x + frame.w - newx);
    if (distcheck < closedist) {
      whichwall = "right";
      closedist = distcheck;
    }
    distcheck = Math.abs(frame.y + frame.h - newy);
    if (distcheck < closedist) {
      whichwall = "bottom";
      closedist = distcheck;
    }
    distcheck = Math.abs(frame.y - newy);
    if (distcheck < closedist) {
      whichwall = "top";
      closedist = distcheck;
    }
    return whichwall;
  };

  p.putlauncher = function(newx, newy) {
    // for making rounding the corners easier, but need to be careful when there are bushes present not to let user "snap" to another wall through a bush - so maybe only when near a corner

    // keep from going way outside frame
    if (newx < frame.x) {
      newx = frame.x;
    }
    if (newx > frame.x + frame.w) {
      newx = frame.x + frame.w;
    }
    if (newy < frame.y) {
      newy = frame.y;
    }
    if (newy > frame.y + frame.h) {
      newy = frame.y + frame.h;
    }

    var whichwall = this.launcherwall(newx, newy);
    if (!launcher.onwall) {
      launcher.onwall = whichwall;
    }
    // but only switch walls if near the corner
    if (whichwall != launcher.onwall) {
      if (!this.launchernearcorner()) {
        whichwall = launcher.onwall;
      } else {
        launcher.onwall = whichwall;
      }
    }

    switch (whichwall) {
      case "left":
        newx = frame.x;
        slidemode = "v";
        break;

      case "top":
        newy = frame.y;
        slidemode = "h";
        break;

      case "right":
        newx = frame.x + frame.w;
        slidemode = "v";
        break;

      case "bottom":
        newy = frame.y + frame.h;
        slidemode = "h";
        break;
    }

    if (block && !this.editmode) {
      // check for blocking bushes, unless we're in editmode
      var bushwidth = app.config.items.bush.frame.w;
      var bushheight = app.config.items.bush.frame.h;
      var lockout = false;
      var lx = launcher.position.x;
      var ly = launcher.position.y;
      var b, blockpos;
      if (slidemode == "v") {
        var blockytop, blockybottom;
        for (b in block[whichwall]) {
          blockytop = block[whichwall][b] + frame.y - bushheight / 2;
          blockybottom = blockytop + bushheight;
          if (ly <= blockytop) {
            if (newy > blockytop) {
              newy = blockytop;
            }
          } else if (ly >= blockybottom) {
            if (newy < blockybottom) {
              newy = blockybottom;
            }
          }
        }
      } else if (slidemode == "h") {
        var blockxleft, blockxright;
        for (b in block[whichwall]) {
          blockxleft = block[whichwall][b] + frame.x - bushwidth / 2;
          blockxright = blockxleft + bushwidth;
          if (lx <= blockxleft) {
            if (newx > blockxleft) {
              newx = blockxleft;
              lockout = true;
            }
          } else if (lx >= blockxright) {
            if (newx < blockxright) {
              newx = blockxright;
            }
          }
        }
      }
    }

    launcher.position.x = newx; //ev.data.global.x;
    launcher.position.y = newy; //ev.data.global.y;

    if (this.aim()) {
      //this.aimpenguins({x:newx,y:newy}); // penguins follow the aim?
      if (this.guideon) {
        this.showguide();
      }
    }
  };

  p.getclosewalls = function() {
    closewalls = [];
    var radius = 10;
    if (launcher.position.x <= frame.x + radius) {
      closewalls.push("leftwall");
    } else if (launcher.position.x >= frame.x + frame.w - radius) {
      closewalls.push("rightwall");
    }

    if (launcher.position.y <= frame.y + radius) {
      closewalls.push("topwall");
    } else if (launcher.position.y >= frame.y + frame.h - radius) {
      closewalls.push("bottomwall");
    }
  };

  p.droplauncher = function(ev) {
    this.container.off(app.dragtype, this.movelauncher);
    this.container.off(app.releasetype, this.droplauncher);
    this.parent.panel.off(app.releasetype, this.droplauncher);
    this.container.off(app.outtype, this.droplauncher);

    /* //TODO: Should it shoot if you haven't moved it? Some users click on launcher expecting it to shoot
		if(launcher.mayshoot && launcher.last.distance(launcher.position) < 100) {
			//this.shootit(this.forcelevel);
			this.parent.shootit();
		}
	*/

    launcher.last.x = launcher.position.x;
    launcher.last.y = launcher.position.y;
    this.parent.droppedlauncher(ev);
  };

  p.getdistbetweenobjects = function(obj1, obj2) {
    var x = obj1.vis.position.x - obj2.vis.position.x;
    var y = obj1.vis.position.y - obj2.vis.position.y;
    return x * x + y * y;
  };

  p.startsim = function() {
    t1 = 0;
    t3 = 0;

    app.off("update", this.update);
    app.on("update", this.update);

    phys.events.off("collide", this.collision);
    phys.events.on("collide", this.collision);

    phys.events.off("sense", this.sense);
    phys.events.on("sense", this.sense);

    phys.events.off("stopsense", this.stopsense);
    phys.events.on("stopsense", this.stopsense);
  };

  p.beginnewshot = function() {
    // get a bunch of things set up for a new shot
    shot++;
    historyframe = 0;
    this.distancefromtarget=1000000;
    this.history[shot] = { steps: {}, initial: {} };

    // turn off the guide
    this.clearguide();
    this.savepositionstohistory();
    stasis = false;
    noshot = false;
    reloading = true;
    stoppredicting = true;
    shotstaken++;
    this.events.trigger("shot");
    if (shotstaken >= gamesettings.shotlimit) {
      this.outofshots();
    }
    app.setTimeout(this.reload, 1000);
  };

  p.getlauncherspec = function() {
    var launcherspec = {
      position: { x: launcher.position.x, y: launcher.position.y },
      force: this.forcelevel,
      rotation: launcher.rotation,
      lockforce: launcher.lockforce,
      lockposition: launcher.lockposition
    };
    return launcherspec;
  };

  p.getlauncher = function() {
    return launcher;
  };

  p.savepositionstohistory = function() {
    this.history[shot].initial = this.completegamestate();

    var wl = worldobjects.length - 1;
    for (var o = wl; o >= 0; o--) {
      var obj = worldobjects[o];
      if (obj.status == "dead") {
        // died already; clear it from the next screen.
        worldobjects.splice(o, 1);
        continue;
      }
      var m = obj.getnewpos();
      if (!this.history[shot].steps[obj.name]) {
        this.history[shot].steps[obj.name] = [];
      }
      this.history[shot].steps[obj.name][historyframe] = [m.x, m.y, m.r];
      lastframes[obj.name] = historyframe;
    }
  };

  p.completegamestate = function() {
    var wstate1 = phys.savescaledworldstate();
    var wstate = [];
    for (var d in wstate1) {
      if (
        wstate1[d].obj.id === "movingpenguin" &&
        wstate1[d].obj.pathstep !== null
      ) {
        // save where the movingpenguin was headed
        wstate1[d].obj.savepathstep = wstate1[d].obj.pathstep;
      }

      if (wstate1[d].obj.type !== "wall") {
        // don't save walls
        wstate.push(wstate1[d]);
      }
    }

    var stateobj = { gamelayout: wstate, launcher: this.getlauncherspec() };

    stateobj.goal = gamesettings.goal;
    stateobj.force = this.forcelevel;
    stateobj.shots = gamesettings.shotlimit - shotstaken;

    return stateobj;
  };

  p.addnewtohistory = function(name) {
    this.history[shot].steps[name] = [];
    for (var i = 0; i < historyframe; i++) {
      this.history[shot].steps[name][i] = "X";
    }
  };

  p.savecollision = function(obj) {
    if (stasis) return;
    collisions[obj.name] = true;
  };

  p.addcollision = function(obj, frame) {
    if (frame < 0) return;

    if (obj.notrace) return;

    var mstep = this.history[shot].steps[obj.name];

    m = mstep[frame];
    if (m && m.length) {
      m[3] = true;
    } else {
      m = mstep[lastframes[obj.name]];
      mstep[frame] = [m[0], m[1], m[2], collisions[obj.name]];

      if (frame > lastframes[obj.name]) {
        lastframes[obj.name] = frame;
      }
    }

    collisions[obj.name] = false;
  };

  p.saveposition = function(obj) {
    if (stasis) return 0;
    var m = obj.getlastmove();

    if (!this.history[shot].steps[obj.name]) {
      this.addnewtohistory(obj.name);
    }

    if (obj.status == "dead" && !collisions[obj.name]) {
      this.history[shot].steps[obj.name][historyframe] = "X";
      return 0;
    }

    if (m !== 0) {
      this.history[shot].steps[obj.name][historyframe] = [m[0], m[1], m[2]];
      if (collisions[obj.name]) {
        this.addcollision(obj, historyframe);
      }

      lastframes[obj.name] = historyframe;

      return 1;
    } else if (collisions[obj.name]) {
      this.addcollision(obj, historyframe);
      return 0;
    } else {
      this.history[shot].steps[obj.name][historyframe] = lastframes[obj.name]; // point to the last frame that has a position
      return 0;
    }
  };

  p.update = function(t) {
    var me = this;

    t1 += t;
    t3 += t;

    if (t1 > vistick) {
      if (t3 > phystick) {
        historyframe++;
        // save the new positions
        this.physupdate(t2);
        t3 = 0;
      }

      rend.update(t1);

      t1 = 0;

      if (this.aim()) {
        if (this.guideon) {
          this.showguide();
        }
      }

      var d = this.checkvictory();

      if (this.plushie.speed > 0.03) {
        if (this.plushie.insand && this.plushie.speed > 0.08) {
          app.soundtrack.playAmbient("sandslide");
        } else {
          app.soundtrack.playAmbient("iceslide");
        }
      } else {
        app.soundtrack.playAmbient(); // no slide sound
      }

      if (stasis) {
        app.soundtrack.playAmbient(); // no slide sound
      }

      if (tracepaths) {
        this.showpaths();
      }
    }
  };

  p.physupdate = function(t) {
    phys.update(t);

    var checkstasis = true;
	var distance;
    for (var w in worldobjects) {
      var obj = worldobjects[w];
      obj.recordposition();
      if (obj.status === "dead") continue;
      if (obj.type === "wall") continue;

      var m = this.saveposition(obj);
      if (m !== 0 && !obj.wandering) {
        checkstasis = false;

        if (obj.id == "inkball") {
          var ob = rend.oneshot(app.config.items.inktrail);
          rend.addObjectToDisplay(ob, obj);
          rend.setpos(ob.vis, obj.vis.position);
        }
      }

      if (obj.nearhole) {
         distance = this.getdistbetweenobjects(obj, obj.nearhole);
        if (distance < holedistance) {
          if (obj.id == "plushie") {
            this.shotstatus.plushie.icehole = true;
          } else if (obj.id == "fish") {
            this.shotstatus.fish.icehole = true;
          }
          this.fallinhole(obj);
        }
      }
      /*
F(friction) = -k;
F(drag) = speed * speed * -k;
*/

      if (obj.id == "penguin") {
        if (obj.spinning) {
          obj.spin();
        }
      }

      if (obj.id == "fish" || obj.id == "plushie") {
        fv = obj.getworldvelocity();
        s = fv.x * fv.x + fv.y * fv.y;
        obj.speed = s;

        if (s !== 0) {
          var fric = new Point(fv.x * -1, fv.y * -1);
          var drag;

          if (obj.insand) {
            fric.truncate(this.sanddrag);
            drag = [fric.x, fric.y];
            phys.applyForce(obj, drag);
          } else if (s < 5) {
            fric.truncate(this.icedrag);
            drag = [fric.x, fric.y];
            phys.applyForce(obj, drag);
          }
        }
      }

      if (obj.id == "movingpenguin") {
      // let's say moving penguins can fall into the hole too. Ideally this would be done via physics, but moving penguin is a kinetic body, which complicates that.
      	if(obj.splashing) break;
      	obj.nearhole=null;
      	for(var hole in groupedobjects.icehole) {
      		var icehole=groupedobjects.icehole[hole];
      		distance = this.getdistbetweenobjects(obj, icehole);
      		if(distance < 1000) {
   				obj.nearhole=groupedobjects.icehole[hole];
   			}
      	}
        if (obj.chase) {
          obj.followitem();
        } else {
          // wander
          obj.wander();
        }
      }
    }
    
    if (checkstasis) {
      // nothing is moving, so it's the end of a turn OR shot hasn't been fired
      if (!stasis) {
        // things weren't already in stasis, so this is the end of a turn.
        this.events.trigger("stasis"); // new stasis
        this.stopsim();
        stasis = true;
      }
    }
  };

  p.stopsim = function() {
    collisionsounds = false;
    app.off("update", this.update);
    phys.events.off("collide", this.collision);
    phys.events.off("sense", this.sense);
    phys.events.off("stopsense", this.stopsense);
  };

  p.noplay = function(oryes) {
    if (oryes === false) {
      this.notplaying = false;
    } else {
      this.notplaying = true;
    }
  };

  p.checkpredict = function() {
    if (!predict) return true;

    if (this.usertarget) return true;

    return false;
  };

  p.checkvictory = function() {
    // check to see whether the plushie is (completely?) in the target. Quickest would be to compare the centers.

    // plushie should be moving slowly enough though
    if (this.notplaying || noshot) return;

    var maywin = false;

    var d = Math.distSq(
      this.plushie.vis.position.x,
      this.plushie.vis.position.y,
      this.target.vis.position.x,
      this.target.vis.position.y
    );

    if (d < this.closest) {
      this.closest = d;
      // which side?
      var fv = this.plushie.getworldvelocity();
    }

    if (!stasis || this.plushie.speedsq() > restspeed) return;

    if (maywin) {
      this.didwin(2);
      d = 0;
    }

    if (
      gamesettings.goal.type === "predict" &&
      gamesettings.goal.config === "stars"
    ) {
      // would say something about the number of stars
      // always "win" with stars, but it's just a way of calling the judgement

      if (this.judgestatus() === "winstars") {
        this.didwin();
        return 0;
      }

      this.didlose(); // always lose at stars
      return 0;
    }

    if (d < victorydistance.l || this.plushie.intarget) {
      var accuracy = 0;
      if (d < victorydistance.l) {
        accuracy = 1;
        if (d < victorydistance.m) {
          accuracy = 2;
          if (d < victorydistance.s) {
            accuracy = 3;
          }
        }
      }

      maywin = true;
      this.didwin(accuracy);
      d = 0;
    }
    if (!maywin && gamesettings.shotlimit - shotstaken <= 0) {
      // that was the last shot!
      this.didlose();
    }

    return d;
  };

  p.fallinhole = function(obj) {
    if (obj.splashing) return;

    this.gamesound("splash");
    var p = obj.nearhole.getworldposition();

    obj.splashing = true;
    var sp = this.panel.additem(app.config.items.splash, this.container);
     // put the splash at the same level as the hole and move the object under it, otherwise the plushie goes 'under' the ice hole
    this.container.setChildIndex(sp, this.container.getChildIndex(obj.nearhole.vis)+1);
    this.container.setChildIndex(obj.vis, this.container.getChildIndex(sp));
    
    obj.setworldposition(p.x, p.y, obj.getrotation());
    obj.setworldvelocity(0, 0);
    sp.position = {
      x: obj.nearhole.vis.position.x - 61,
      y: obj.nearhole.vis.position.y - 47
    };
    sp.doonce();
    var me = this;
    sp.events.on("done", function(ev) {
      me.panel.removeitem(ev);
      me.removeitem(obj);
      obj.splashing = false;
      if (obj.id === "plushie") {
        me.stasis = true;
      }
    });
  };

  p.didwin = function(accuracy, prediction) {
    this.stopsim();
    this.noplay();

    this.panel.showitem("buttonnext");


    var j = "";
    switch (accuracy) {
      case 3:
        j = "bullseye";
        this.targetvictory.showring(1);
        break;

      case 2:
        j = "innerring";
        this.targetvictory.showring(2);
        break;

      case 1:
        j = "outerring";
        this.targetvictory.showring(3);
        break;

      case 0:
        this.targetvictory.showring(4);
        j = "edge";
        break;
    }

    this.showretry("win");
    var more=this.winfeedback();
    more.push(j);
    
    var pick=more[parseInt(Math.random() * more.length)];

    this.events.trigger("feedback", {
      type: "success",
      goal: gamesettings.goal,
      status: pick
    });

  };
  
  p.winfeedback = function() {
    var poslocked = gamesettings.launcher.lockposition;
    var forcelocked = gamesettings.launcher.lockforce;
    var possible=[];
    // it was a force-only level with the right force
    if(poslocked && !forcelocked) {
      possible.push("rightforce");
    }
    
    var hitwall,hitpenguin,hitmover,therewerepenguins;
    // hit no obstacles
   
    
    // bounced off the wall
    for(var ob in this.shotstatus.plushie.obstacles) {
      if(this.shotstatus.plushie.obstacles[ob].id==="movingpenguin") {
          hitmover=true;
      } else if(this.shotstatus.plushie.obstacles[ob].id==="penguin") {      
          hitpenguin=true;
      } else if(this.shotstatus.plushie.obstacles[ob].id.indexOf("wall") > -1) {
          hitwall=true;
      }
    }
    
    if(!hitmover && !hitpenguin) {
      // were there any penguins to hit?
      var werepenguins=false;
      for(var wo in worldobjects) {
        if(worldobjects[wo].id==="penguins" || worldobjects[wo].id==="movingpenguins") {
          werepenguins=true;
        }
      }
      if(werepenguins) {
        possible.push("missedpenguins");
      }
    }
    
    if(hitmover) {
      possible.push("movingpenguinbank");
    }
    
    if(hitpenguin) {
     possible.push("penguinbank");
    }
    
    if(hitwall) {
      possible.push("bankshot");
    }
    return possible;
  };

  p.didlose = function() {
    this.stopsim();
    this.distancefromtarget=Math.distSq(
      this.plushie.vis.position.x,
      this.plushie.vis.position.y,
      this.target.vis.position.x,
      this.target.vis.position.y
    );
    var message = this.judgestatus();

    this.events.trigger("feedback", {
      type: "fail",
      goal: gamesettings.goal,
      status: message
    });

    var encourage = "";

    this.noplay();
    this.showretry(); // should you sometimes win in prediction even if you didn't get it right?
  };

  p.showretry = function(status) {
    this.parent.showretry(status);
  };

  p.judgestatus = function() {
    var oi, ob;

    var poslocked = gamesettings.launcher.lockposition;
    var forcelocked = gamesettings.launcher.lockforce;

    if (gamesettings.goal.type === "predict") {
      // they didn't choose the right target, or we say something about the stars.
      if (gamesettings.goal.config === "stars") {
        /* star id can be
					1. "stargot" - user thought plushie would go here, and it did
					2. "starguess" - user thought plushie would not go here, and it didn't
					3. "bonus" - user thought plushie would go here and it didn't
					4. "starmissed" - user didn't think plushie would go here and it did
					*/

        this.shotstatus.stars = { userguess: [], correct: [], incorrect: [] };

        for (var o in worldobjects) {
          var obj = worldobjects[o];
          if (obj.type === "star") {
            var pos = obj.getscaledworldposition();
            pos = this.adjustpos([pos.x, pos.y], true, true);
            if (!this.shotstatus.stars[obj.id]) {
              this.shotstatus.stars[obj.id] = 1;
            } else {
              this.shotstatus.stars[obj.id]++;
            }
            if (obj.id === "bonus") {
              // take away ones they thought were correct but aren't.
              obj.changeimage("starnope");
              this.shotstatus.stars.incorrect.push(pos);
              this.shotstatus.stars.userguess.push(pos);
            }

            switch (obj.id) {
              case "stargot":
                this.shotstatus.stars.correct.push(pos);
                this.shotstatus.stars.userguess.push(pos);
                break;

              case "starguess":
                this.shotstatus.stars.incorrect.push(pos);
                break;

              case "starmissed":
                this.shotstatus.stars.correct.push(pos);
                obj.changeimage("starnogo");
                break;
            }
          }
        }

        if (!this.shotstatus.stars.stargot) {
          // NO stars matched
          if (!this.shotstatus.stars.bonus) return "starsnochoice"; // user didn't choose any in the first place

          return "starsnone";
        }

        var addendum = "";
        var stars = "stars";
        if (this.shotstatus.stars.bonus) {
          // some stars were chosen but not found
          if (
            !this.shotstatus.stars.starmissed &&
            !this.shotstatus.stars.starguess
          )
            return "starschoseall"; // player chose every star!

          return "starssome";
        }

        if (this.shotstatus.stars.starmissed) { // hit all predicted, but also others.
        	if(this.shotstatus.stars.starguess==1) { // special case for user only chose one star
          		return "starsmorethanone";
          	} else if(this.shotstatus.stars.starmissed==1) { // special case for only one more than the user chose
          		return "starsone";
          	} 
          return "starsshort";
        }

        return "winstars";
      } else {
        // target prediction

        // if they hit a moving penguin, can't say whether the target was right or not.

        for (oi in this.shotstatus.fish.obstacles) {
          ob = this.shotstatus.fish.obstacles[oi].id;
          if (ob == "movingpenguin") {
            return "timingfish";
          }
        }

        for (oi in this.shotstatus.plushie.obstacles) {
          ob = this.shotstatus.plushie.obstacles[oi].id;
          if (ob == "movingpenguin") {
            return "timing";
          }
        }

        return "fail_predict";
      }
    }

    if (!this.shotstatus.plushie.moved) {
      if (this.shotstatus.fish.obstacles.length < 1 && !forcelocked) {
        // only if force is movable
        return "forceverylow";
      }

      if (this.shotstatus.fish.icehole && !poslocked) {
        return "posicehole2";
      }

      for (oi in this.shotstatus.fish.obstacles) {
        ob = this.shotstatus.fish.obstacles[oi].id;
        if (ob == "movingpenguin") {
          return "timingfish";
        }
        if (ob == "penguin") {
          if (
            forcelocked ||
            this.shotstatus.force == 10 ||
            !this.predictshot()
          ) {
            return "pospenguinfish";
          } else {
            return "forcelowpenguin";
          }
        }
      }
      if (!forcelocked) {
        return "forcelow";
      } else {
        return "fail_position";
      }
    } else {
      if (!forcelocked && this.shotstatus.plushie.target) {
        return "forcetoohigh";
      }

      if (!poslocked && this.shotstatus.plushie.icehole) {
        return "posicehole";
      }

      for (oi in this.shotstatus.plushie.obstacles) {
        ob = this.shotstatus.plushie.obstacles[oi].id;
        if (ob == "movingpenguin") {
          return "timing";
        }
        if (ob == "penguin") {
          if (
            forcelocked ||
            this.shotstatus.force == 10 ||
            !this.predictshot()
          ) {
            return "pospenguin";
          } else {
            return "forcelowpenguin";
          }
        }
      }

      if (!poslocked && (this.shotstatus.force == 10 || !this.predictshot())) {
        return "fail_position";
      } else if (!forcelocked) {
        return "forcelow";
      } else {
        return "again"; // try again?
      }
    }
  };

  /**** CREATE MODE ****/

  p.putdown = function(placeid, posin) {
    if (!this.editmode) return;
    if (!placeid) return;

    var pos = this.localpos(posin);
    var it = this.placeitem(placeid, [pos.x, pos.y]);
    it.activate(this.dragitem);
    phys.update(1);
    rend.update(1);
    this.showlayout();

    this.dragging = it;
    this.dragoffset = { x: 0, y: 0 };
    var gvp = it.getvisualposition();
    if (this.dragging.id === "penguin" || this.dragging.id == "movingpenguin") {
      this.dragging.setrotation(120 * Vector.DEG2RAD, true);
    }
    
    
    if (this.dragging.config.dragimage) {
      this.dragging.changeimage(this.dragging.config.dragimage);
    }
    
    this.dragging.isnew = true;
    this.dragging.snapback = { x: gvp.x, y: gvp.y };
    this.container.off(app.dragtype, this.moveitem);
    this.container.off(app.releasetype, this.dropitem);
    this.container.on(app.dragtype, this.moveitem);
    this.container.on(app.releasetype, this.dropitem);

    return it;
  };

  p.toggleedit = function() {
    if (!this.editmode) {
      this.startedit();
    } else {
      this.stopedit();
    }
  };

  p.startedit = function() {
    this.editmode = true;

    this.stopsim();
    // make all game items movable (not walls)
    for (var o in worldobjects) {
      var obj = worldobjects[o];
      if (obj.nomove) continue;

      obj.activate(this.dragitem);
      if(obj.config.dragimage) {
         obj.changeimage(obj.config.dragimage);
      }
      switch (obj.id) {
        case "targetplace":
          obj.deactivate(this.placetarget);
          break;

        case "starguess":
          obj.deactivate(this.togglestar);
          break;

        case "movingpenguin":
          // put this back up on its start point
          this.connectmovingpenguin(obj);
          break;
      }
    }

    // make sure the launcher is movable also
    this.notplaying = false;

    this.updatepenguinpaths();
    this.penguinpathlayer.visible = true;
    rend.update();
  };

  p.hintclosed = function() {
    this.noplay(false);
  };

  p.stopedit = function() {
    this.editmode = false;
    // all world items unmovable
    this.cleareditthings();
  };

  p.connectmovingpenguin = function(movingpenguin) {
    movingpenguin.stopchasing(true);
    movingpenguin.pathstep = 0;

    movingpenguin.setvisualposition(
      movingpenguin.special.path[0][0],
      movingpenguin.special.path[0][1]
    );
    var point = new Point(
      movingpenguin.special.path[1][0],
      movingpenguin.special.path[1][1]
    );
    movingpenguin.turntoface(point); // face the first position
    for (var ind = 1; ind < movingpenguin.special.path.length; ind++) {
      var newpos = [
        movingpenguin.special.path[ind][0],
        movingpenguin.special.path[ind][1]
      ];
      var spot = this.placeitem("penguinpathpoint", newpos);
      spot.activate(this.dragitem);
      spot.type = "editonly";
      spot.whatpoint = { obj: movingpenguin, index: ind };
    }
  };

  p.cleareditthings = function() {
    for (var o in worldobjects) {
      var obj = worldobjects[o];
      if (obj.nomove) continue;
      obj.vis.interactive = false;
      obj.vis.off(app.taptype, this.dragitem);
      if (obj.type == "editonly") {
        this.removeitem(obj);
      }
    }
    this.removealldeadobjects();
    rend.drawline(this.penguinpathlayer, false);
    this.penguinpathlayer.visible = false;
  };

  p.showeditthings = function() {};

  p.savecreatedlevel = function() {
    var newlevel = this.showlayout();

    newlevel.hint = "User Level";

    this.parent.saveuserlevel(newlevel);
  };

  p.noforcealert = function() {
  	// TODO? Allow user to try launch with 0 force?
  };

  p.gamesound = function(soundname, force) {
    if (collisionsounds || force) {
      app.soundtrack.playSFX(soundname);
    }
  };

  p.nopredictalert = function() {
    this.parent.predictalert();
  };

  /**
	 * When the state fully exits
	 * @method  exit
	 */
  p.teardown = function() {  
    this.clearguide();
    this.clearlevel();
    this.editmode = false;
    this.stopsim();
  };

  //Assign to namespace
  namespace("WGBH").IceRink = IceRink;
})();
